import { useEventContext } from '../../hooks/contexts/event.context';
import { useI18nContext } from '../../hooks/contexts/i18n.context';
import SectionDiscountsAndPassKey, { SectionDiscountsAndPassKeyProps } from './Section';
import * as Styles from './styles.discount';

const DiscountsAndPassKey = () => {
  const { translate } = useI18nContext();
  const { passKeyApplied, couponApplied, isOGlobo, signatureOGloboApplied } = useEventContext();

  const options: SectionDiscountsAndPassKeyProps[] = [
    {
      idRef : 0,
      title : translate(['INFORMATION', 'CODE']),
      content : translate(['INFORMATION', 'CODE_DESCRIPTION']),
      opened : false,
      type : 'passkey'
    },
    {
      idRef : 1,
      title : translate(['INFORMATION', 'COUPON']),
      content : translate(['INFORMATION', 'COUPON_DESCRIPTION']),
      opened : false,
      type : 'coupon'
    }
  ];

  if (isOGlobo) {
    options.push({
      idRef : 2,
      title : translate(['INFORMATION', 'O_GLOBO']),
      content : translate(['INFORMATION', 'O_GLOBO_DESCRIPTION']),
      opened : false,
      type : 'o-globo',
    });
  }

  return (
    <Styles.Wrapper id="discounts-passkey-wrapper">
      {
        options.filter(({ type }) => {
          if (!passKeyApplied && !couponApplied) return true;
          if (type === 'passkey' && passKeyApplied) return true;
          if (type === 'coupon' && couponApplied && !signatureOGloboApplied) return true;
          if (type === 'o-globo' && signatureOGloboApplied) return true;
        }).map(({ title, content, opened, type }, key) => (
          <SectionDiscountsAndPassKey
            key={title}
            title={title}
            content={content}
            opened={opened}
            type={type}
            idRef={key}
          />
        ))
      }
    </Styles.Wrapper>
  );
};

export default DiscountsAndPassKey;
